/**
 * React Application Entry Point - By John Bellew - Infinia.ie - last updated 10/07/2025
 * 
 * The main entry point for the Irish Funds Member Portal with advanced features:
 * - React 18 createRoot API for concurrent features
 * - Auth0 authentication provider integration
 * - Environment-based configuration management
 * - Root DOM element mounting and initialization
 * - Authentication parameter configuration
 * - Audience and redirect URI setup
 * 
 * Features:
 * - Modern React 18 root rendering with concurrent features
 * - Auth0 authentication wrapper for secure access
 * - Environment variable-based configuration
 * - Automatic redirect URI detection
 * - Authentication audience specification
 * - Clean separation of concerns
 * 
 * Authentication Configuration:
 * - Domain: REACT_APP_AUTH0_DOMAIN environment variable
 * - Client ID: REACT_APP_AUTH0_CLIENT_ID environment variable
 * - Audience: REACT_APP_AUTH0_AUDIENCE environment variable
 * - Redirect URI: Current window origin for flexible deployment
 * 
 * @requires react React library for component rendering
 * @requires react-dom React DOM for browser rendering
 * @requires auth0-react Auth0 authentication provider
 * @returns {void} Renders the authenticated application to the DOM
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <App />
);